import React, { useCallback, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import ComplementoGuiaExame from './ComplementoGuiaExame';

// Troca de cargo na Convenia → e-mail à medicina pedindo o exame de mudança de
// função (30/10/2026). Texto editável com rascunho salvo na pendência; o envio
// passa pela prévia (o Enviar fica lá) e usa o fluxo de exames de sempre, que
// fecha a pendência sozinho.
const API = `${process.env.REACT_APP_API_BASE}/api/bporh`;
const cab = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem('access')}` } });
const TIPO = 'mudanca_risco';

function ExameMudancaCargo({ pendencia, onFechar, onConcluido }) {
  const [d, setD] = useState(null);
  const [erro, setErro] = useState('');
  const [msg, setMsg] = useState('');
  const [ocupado, setOcupado] = useState('');
  const [previa, setPrevia] = useState(null);
  const [dispensa, setDispensa] = useState(null);   // motivo em edição

  const carregar = useCallback(() => {
    setErro('');
    axios.get(`${API}/exames/mudanca-cargo/`, { params: { id: pendencia.id }, ...cab() })
      .then((res) => {
        const x = res.data;
        setD({
          ...x, operador_id: (x.remetentes || [])[0]?.id || '', data: '',
          assunto: x.email?.assunto || '', corpo: x.email?.corpo || '',
          destinatario: x.config?.clinica_email || '', salvo: { assunto: x.email?.assunto, corpo: x.email?.corpo },
        });
      })
      .catch((err) => setErro(err.response?.data?.mensagem || 'Não foi possível montar o e-mail'));
  }, [pendencia.id]);
  useEffect(() => { carregar(); }, [carregar]);

  const clienteId = pendencia.cliente_id;
  const convId = pendencia.convenia_id;
  const alterado = d && (d.assunto !== d.salvo.assunto || d.corpo !== d.salvo.corpo);
  const podeEnviar = d && d.operador_id && d.config?.clinica_email && !(d.faltando || []).length;

  const salvarTexto = () => {
    setOcupado('salvar'); setMsg('');
    axios.post(`${API}/exames/mudanca-cargo/`, { id: pendencia.id, acao: 'salvar', assunto: d.assunto, corpo: d.corpo }, cab())
      .then((res) => {
        setMsg(res.data.mensagem || 'Texto salvo');
        setD(x => ({ ...x, rascunho: true, rascunho_info: 'salvo agora', salvo: { assunto: x.assunto, corpo: x.corpo } }));
      })
      .catch((err) => setMsg(err.response?.data?.mensagem || 'Não foi possível salvar o texto'))
      .finally(() => setOcupado(''));
  };
  const restaurarTexto = () => {
    setOcupado('restaurar'); setMsg('');
    axios.post(`${API}/exames/mudanca-cargo/`, { id: pendencia.id, acao: 'restaurar' }, cab())
      .then(() => carregar())
      .catch((err) => setMsg(err.response?.data?.mensagem || 'Não foi possível restaurar'))
      .finally(() => setOcupado(''));
  };
  const salvarDestinatario = () => {
    const email = (d.destinatario || '').trim();
    if (!email) { setMsg('Informe o e-mail da clínica'); return; }
    setOcupado('dest');
    axios.post(`${API}/exames/solicitar/`, { cliente_id: Number(clienteId), config: { ...d.config, clinica_email: email } }, cab())
      .then((res) => setD(x => ({ ...x, config: res.data.config, destinatario: res.data.config?.clinica_email || email })))
      .catch((err) => setMsg(err.response?.data?.mensagem || 'Não foi possível salvar o destinatário'))
      .finally(() => setOcupado(''));
  };
  const verGuia = () => {
    axios.get(`${API}/exames/solicitar/`, {
      params: { cliente_id: clienteId, convenia_id: convId, pdf: 1, tipo: TIPO, data_exame: d.data || '' },
      ...cab(), responseType: 'blob',
    })
      .then((res) => window.open(URL.createObjectURL(res.data), '_blank'))
      .catch(() => setMsg('Não foi possível gerar a guia'));
  };
  // todo envio passa pela prévia: o e-mail como vai sair + a guia em PDF
  const abrirPrevia = () => {
    setPrevia({ carregando: true });
    Promise.all([
      axios.post(`${API}/exames/solicitar/`, {
        cliente_id: Number(clienteId), convenia_id: convId, visualizar: true, tipo_exame: TIPO,
        data_exame: d.data || null, operador_id: d.operador_id || null, assunto: d.assunto, corpo: d.corpo,
      }, cab()),
      axios.get(`${API}/exames/solicitar/`, {
        params: { cliente_id: clienteId, convenia_id: convId, pdf: 1, tipo: TIPO, data_exame: d.data || '' },
        ...cab(), responseType: 'blob' }),
    ])
      .then(([email, pdf]) => setPrevia({ ...email.data, carregando: false,
        pdfUrl: URL.createObjectURL(new Blob([pdf.data], { type: 'application/pdf' })) }))
      .catch((err) => { setPrevia(null); setMsg(err.response?.data?.mensagem || 'Não foi possível montar a prévia'); });
  };
  const fecharPrevia = () => {
    if (previa?.pdfUrl) URL.revokeObjectURL(previa.pdfUrl);
    setPrevia(null);
  };
  const enviar = () => {
    setOcupado('enviar');
    axios.post(`${API}/exames/solicitar/`, {
      cliente_id: Number(clienteId), convenia_ids: [convId], operador_id: d.operador_id,
      tipo_exame: TIPO, data_exame: d.data || null, assunto: d.assunto, corpo: d.corpo,
    }, cab())
      .then((res) => { fecharPrevia(); onConcluido(res.data.mensagem || 'E-mail enviado à clínica'); })
      .catch((err) => setMsg(err.response?.data?.mensagem || 'Não foi possível enviar'))
      .finally(() => setOcupado(''));
  };
  const dispensar = () => {
    setOcupado('dispensar');
    axios.post(`${API}/exames/mudanca-cargo/`, { id: pendencia.id, acao: 'dispensar', motivo: dispensa }, cab())
      .then((res) => onConcluido(res.data.mensagem || 'Pendência dispensada'))
      .catch((err) => setMsg(err.response?.data?.mensagem || 'Não foi possível dispensar'))
      .finally(() => setOcupado(''));
  };

  return (
    <div className="modal fade show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 10002 }}
      onClick={(e) => { if (e.target === e.currentTarget && !ocupado) onFechar(); }}>
      <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
        <div className="modal-content shadow-lg">
          <div className="modal-header bg-white">
            <div>
              <h5 className="modal-title" style={{ color: '#212529' }}>
                <i className="fas fa-stethoscope me-2" style={{ color: '#00b5cc' }}></i>Exame de mudança de função
              </h5>
              <div className="small" style={{ color: '#6c757d' }}>
                {pendencia.nome} · {pendencia.cliente} · <b>{pendencia.cargo_anterior}</b> → <b>{pendencia.cargo_novo}</b>
                {pendencia.data_alteracao && <> em {pendencia.data_alteracao}</>}
                {d?.config?.clinica_nome && <> · clínica <b>{d.config.clinica_nome}</b></>}
              </div>
            </div>
            <button type="button" className="btn-close" disabled={!!ocupado} onClick={onFechar}></button>
          </div>
          <div className="modal-body">
            {erro && <div className="alert alert-danger py-2 small mb-0">{erro}</div>}
            {!d && !erro && <div className="text-center py-4"><span className="spinner-border text-primary"></span></div>}
            {d && (
              <>
                {!d.config?.empresa && (
                  <div className="alert alert-warning py-2 small">
                    <i className="fas fa-triangle-exclamation me-2"></i>
                    Este cliente ainda não tem os <b>dados da guia</b> (empresa, CNPJ, unidade, clínica). Cadastre em{' '}
                    <Link to={`/Dp/Exame%20Mensal?cliente=${clienteId}`} target="_blank">Exame Mensal → Dados da guia</Link>.
                  </div>
                )}
                {d.cargo_guia_diferente && (
                  <div className="alert alert-warning py-2 small">
                    <i className="fas fa-triangle-exclamation me-2"></i>
                    O cadastro ainda mostra o cargo <b>{d.colaborador?.cargo_guia || '—'}</b>, e é ele que sai na guia em PDF.
                    Ajuste o cargo da guia em “Dados que faltam na guia” se precisar.
                  </div>
                )}
                <div className="row g-3">
                  <div className="col-md-7">
                    <label className="form-label small fw-semibold mb-1">E-mail da clínica (destinatário)</label>
                    <div className="input-group input-group-sm">
                      <input type="text" className="form-control" placeholder="agendamento@clinica.com.br; coordenacao@..."
                        value={d.destinatario} onChange={(e) => setD(x => ({ ...x, destinatario: e.target.value }))} />
                      {(d.destinatario || '').trim() !== (d.config?.clinica_email || '') && (
                        <button className="btn btn-outline-primary" type="button" disabled={ocupado === 'dest'}
                          onClick={salvarDestinatario} title="Grava na configuração da guia deste cliente">
                          {ocupado === 'dest' ? <span className="spinner-border spinner-border-sm"></span> : 'Salvar'}
                        </button>
                      )}
                    </div>
                    {!d.config?.clinica_email && (
                      <div className="form-text text-danger">Sem e-mail da clínica o envio é recusado — informe e salve.</div>
                    )}
                  </div>
                  <div className="col-md-5">
                    <label className="form-label small fw-semibold mb-1">Operador que assina</label>
                    <select className="form-select form-select-sm" value={d.operador_id}
                      onChange={(e) => setD(x => ({ ...x, operador_id: e.target.value }))}>
                      <option value="">Selecione…</option>
                      {(d.remetentes || []).map(r => <option key={r.id} value={r.id}>{r.nome}</option>)}
                    </select>
                  </div>
                  <div className="col-md-4">
                    <label className="form-label small fw-semibold mb-1">Data do exame (opcional)</label>
                    <input type="date" className="form-control form-control-sm" value={d.data}
                      onChange={(e) => setD(x => ({ ...x, data: e.target.value }))} />
                  </div>
                  <div className="col-md-8">
                    <label className="form-label small fw-semibold mb-1">Assunto</label>
                    <input type="text" className="form-control form-control-sm" value={d.assunto}
                      onChange={(e) => setD(x => ({ ...x, assunto: e.target.value }))} />
                  </div>
                  <div className="col-12">
                    <div className="d-flex align-items-end justify-content-between mb-1">
                      <label className="form-label small fw-semibold mb-0">Texto do e-mail</label>
                      <span className="small text-muted">
                        {d.rascunho ? <>texto editado · {d.rascunho_info}</> : 'texto padrão'}
                      </span>
                    </div>
                    <textarea className="form-control form-control-sm" rows={12} value={d.corpo}
                      onChange={(e) => setD(x => ({ ...x, corpo: e.target.value }))} />
                    <div className="d-flex flex-wrap gap-2 align-items-center mt-2">
                      <button type="button" className="btn btn-sm btn-outline-primary" disabled={!alterado || !!ocupado} onClick={salvarTexto}>
                        {ocupado === 'salvar' ? <span className="spinner-border spinner-border-sm me-1"></span> : <i className="fas fa-floppy-disk me-1"></i>}
                        Salvar texto
                      </button>
                      {d.rascunho && (
                        <button type="button" className="btn btn-sm btn-light border" disabled={!!ocupado} onClick={restaurarTexto}>
                          <i className="fas fa-rotate-left me-1"></i>Voltar ao texto padrão
                        </button>
                      )}
                      <span className="form-text m-0">A guia em PDF vai anexada; cópia ao grupo de e-mail do cliente, quando cadastrado.</span>
                    </div>
                  </div>
                </div>
                <ComplementoGuiaExame clienteId={clienteId} conveniaId={convId} faltando={d.faltando} onSalvo={carregar} />
                {(d.historico || []).length > 0 && (
                  <div className="mt-3 small">
                    <div className="fw-semibold mb-1"><i className="fas fa-clock-rotate-left me-1 text-muted"></i>Pedidos anteriores</div>
                    {d.historico.map((h, i) => (
                      <div key={i} className="text-muted">{h.em} · {h.tipo}{h.data_exame ? ` · exame ${h.data_exame}` : ''} · para {h.para}{h.operador ? ` · por ${h.operador}` : ''}</div>
                    ))}
                  </div>
                )}
                {dispensa !== null && (
                  <div className="border rounded p-2 mt-3 d-flex flex-wrap gap-2 align-items-center" style={{ background: '#f8f9fa' }}>
                    <span className="small">Dispensar sem enviar. Motivo:</span>
                    <input className="form-control form-control-sm" style={{ maxWidth: 340 }} value={dispensa}
                      onChange={(e) => setDispensa(e.target.value)} />
                    <button type="button" className="btn btn-sm btn-primary" disabled={!dispensa.trim() || !!ocupado} onClick={dispensar}>Confirmar</button>
                    <button type="button" className="btn btn-sm btn-outline-secondary" onClick={() => setDispensa(null)}>Cancelar</button>
                  </div>
                )}
                {msg && <div className="small mt-2" style={{ color: '#495057' }}>{msg}</div>}
              </>
            )}
          </div>
          <div className="modal-footer bg-white flex-wrap gap-2">
            <div className="me-auto d-flex gap-2 flex-wrap">
              <button type="button" className="btn btn-light border" disabled={!d} onClick={verGuia}>
                <i className="fas fa-file-pdf me-2 text-danger"></i>Ver guia (PDF)
              </button>
              <button type="button" className="btn btn-light border" disabled={!d || dispensa !== null}
                onClick={() => setDispensa('Riscos ocupacionais iguais — não precisa de exame')}
                title="A troca de cargo não mudou os riscos (ex.: promoção na mesma função)">
                <i className="fas fa-eye-slash me-2"></i>Dispensar
              </button>
            </div>
            <button type="button" className="btn btn-secondary" disabled={!!ocupado} onClick={onFechar}>Cancelar</button>
            <button type="button" className="btn btn-primary" disabled={!podeEnviar || !!ocupado} onClick={abrirPrevia}
              title="Abre a prévia; o envio é confirmado lá">
              <i className="fas fa-envelope me-2"></i>Ver prévia e enviar
            </button>
          </div>
        </div>
      </div>

      {/* prévia por cima do modal: o Enviar de verdade fica aqui */}
      {previa && (
        <div className="modal fade show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.55)', zIndex: 10003 }}
          onClick={(e) => { if (e.target === e.currentTarget && !ocupado) fecharPrevia(); }}>
          <div className="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
            <div className="modal-content shadow-lg">
              <div className="modal-header bg-white">
                <h5 className="modal-title" style={{ color: '#212529' }}>
                  <i className="fas fa-envelope-open-text me-2" style={{ color: '#00b5cc' }}></i>Prévia do e-mail à clínica
                </h5>
                <button type="button" className="btn-close" disabled={!!ocupado} onClick={fecharPrevia}></button>
              </div>
              <div className="modal-body p-0">
                {previa.carregando ? (
                  <div className="text-center py-5"><span className="spinner-border text-primary"></span>
                    <div className="text-muted small mt-2">Montando o e-mail e a guia…</div></div>
                ) : (
                  <>
                    <div className="px-3 py-2 border-bottom small" style={{ background: '#f8f9fa', lineHeight: 1.7 }}>
                      <div><span className="text-muted" style={{ display: 'inline-block', width: 64 }}>De</span><b>{previa.de}</b></div>
                      <div><span className="text-muted" style={{ display: 'inline-block', width: 64 }}>Para</span><b>{previa.para}</b></div>
                      {previa.cc && <div><span className="text-muted" style={{ display: 'inline-block', width: 64 }}>Cc</span>{previa.cc}</div>}
                      {previa.bcc && <div><span className="text-muted" style={{ display: 'inline-block', width: 64 }}>Cco</span>{previa.bcc}</div>}
                      <div><span className="text-muted" style={{ display: 'inline-block', width: 64 }}>Assunto</span><b>{previa.assunto}</b></div>
                      <div><span className="text-muted" style={{ display: 'inline-block', width: 64 }}>Anexo</span><i className="fas fa-paperclip me-1"></i>{previa.anexo}</div>
                    </div>
                    <div className="row g-0">
                      <div className="col-lg-7 border-end">
                        <iframe title="E-mail" srcDoc={previa.html} sandbox="" style={{ width: '100%', height: '58vh', border: 0, background: '#fff' }} />
                      </div>
                      <div className="col-lg-5">
                        <iframe title="Guia em PDF" src={previa.pdfUrl} style={{ width: '100%', height: '58vh', border: 0 }} />
                      </div>
                    </div>
                  </>
                )}
              </div>
              <div className="modal-footer bg-white">
                {msg && <span className="small me-auto" style={{ color: '#495057' }}>{msg}</span>}
                <button type="button" className="btn btn-secondary" disabled={!!ocupado} onClick={fecharPrevia}>
                  <i className="fas fa-arrow-left me-2"></i>Voltar e ajustar
                </button>
                <button type="button" className="btn btn-primary" disabled={!!ocupado || previa.carregando || !podeEnviar} onClick={enviar}>
                  {ocupado === 'enviar' ? <><span className="spinner-border spinner-border-sm me-2"></span>Enviando…</> : <><i className="fas fa-paper-plane me-2"></i>Enviar à clínica</>}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default ExameMudancaCargo;
